<div class="sz-calendar">
  <div class="sz-calendar__head">
    <button type="button" class="sz-calendar__nav" (click)="prevMonth()" aria-label="Previous month">
      <sz-icon name="chevron-left" [size]="20" />
    </button>
    <div class="sz-calendar__title">{{ monthTitle() }}</div>
    <button type="button" class="sz-calendar__nav" (click)="nextMonth()" aria-label="Next month">
      <sz-icon name="chevron-right" [size]="20" />
    </button>
  </div>

  <div class="sz-calendar__weekdays" aria-hidden="true">
    @for (wd of weekdayLabels(); track $index) {
      <span class="sz-calendar__weekday">{{ wd }}</span>
    }
  </div>

  <div class="sz-calendar__grid" role="grid">
    @for (week of weeks(); track $index) {
      <div class="sz-calendar__week" role="row">
        @for (day of week; track day.iso) {
          <button
            type="button"
            role="gridcell"
            class="sz-calendar__day"
            [class.is-outside]="!day.inMonth"
            [class.is-today]="day.isToday"
            [class.is-selected]="day.isSelected"
            [disabled]="day.disabled"
            [attr.aria-label]="day.ariaLabel"
            [attr.aria-pressed]="day.isSelected"
            (click)="select(day)">
            {{ day.day }}
          </button>
        }
      </div>
    }
  </div>
</div>
